"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorConfig = exports.getROIForegroundColor = void 0;
var ROICalculatorUtils_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorUtils");
var ROICalculator_1 = __importDefault(require("@CommonFrontend/Public/Widgets/ROICalculator"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var styles = __importStar(require("../CommonWidgetRegistry.css"));
var ROICalculator_css_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculator.css");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var lodash_1 = require("lodash");
var getROIForegroundColor = function (style) { return (0, ColorUtils_1.shouldUseDarkText)(style.background.color.abs) ? tokens_1.palette.midnight500 : tokens_1.palette.white; };
exports.getROIForegroundColor = getROIForegroundColor;
exports.ROICalculatorConfig = {
    publicRender: function (_a) {
        var _b;
        var token = _a.token, isPrintMode = _a.isPrintMode, disableImgix = _a.disableImgix, attributes = _a.attributes, style = _a.style;
        return server_1.default.renderToString(react_1.default.createElement(ROICalculator_1.default, {
            payload: {
                inputs: (_b = token.inputs) !== null && _b !== void 0 ? _b : {},
                slider: token.slider,
                roiResult: token.roiResult,
                title: token.title,
                description: token.description,
                backgroundImageUrl: (0, ROICalculatorUtils_1.getOptimisedRoiBackgroundImageUrl)({
                    backgroundImageUrl: token.backgroundImageUrl,
                    disableImgix: !!disableImgix,
                    isPrintMode: isPrintMode,
                }),
                useStaticRangeInput: !!isPrintMode,
                id: (0, utils_1.randomString)(),
                foregroundColor: (0, exports.getROIForegroundColor)(style),
            },
            attributes: attributes,
        }));
    },
    tokenType: {},
    traits: {
        spacingShim: {
            className: styles.roiCalculatorSpacingShim,
        },
        selection: {
            ringMode: "hugging",
            ringBorderRadius: 10,
        },
        styleable: {
            styleKey: "roiCalculator",
            properties: [
                {
                    type: "color",
                    if: function (_, element) {
                        return !element.data.backgroundImageUrl;
                    },
                    label: "Background color",
                    path: "background.color",
                    variable: ROICalculator_css_1.sharedROICalculatorVars.backgroundColor,
                    defaultValue: (0, lodash_1.cloneDeep)(DefaultColors_1.DEFAULT_WHITE),
                },
                {
                    type: "color",
                    if: function (_, element) {
                        return !!element.data.backgroundImageUrl;
                    },
                    label: "Tint color",
                    path: "tint.color",
                    defaultValue: (0, lodash_1.cloneDeep)(DefaultColors_1.DEFAULT_MIDNIGHT),
                    variable: ROICalculator_css_1.sharedROICalculatorVars.tintColor,
                },
                {
                    type: "numerical",
                    if: function (_, element) {
                        return !!element.data.backgroundImageUrl;
                    },
                    label: "Tint opacity",
                    path: "tint.opacity",
                    defaultValue: 40,
                    max: 100,
                    min: 0,
                    withSlider: true,
                    variable: ROICalculator_css_1.sharedROICalculatorVars.tintOpacity
                },
                {
                    type: "numerical",
                    if: function (_, element) {
                        return !!element.data.backgroundImageUrl;
                    },
                    label: "Background image blur",
                    path: "background.imageBlur",
                    variable: ROICalculator_css_1.sharedROICalculatorVars.backgroundImageBlur,
                    defaultValue: 0,
                    min: 0,
                    max: 30,
                    withSlider: true,
                },
                {
                    type: "color",
                    label: "Slider color",
                    path: "highlightColor",
                    variable: ROICalculator_css_1.sharedROICalculatorVars.highlightColor,
                    defaultValue: {
                        themeIndex: 0,
                    }
                },
            ]
        }
    },
    type: "roiCalculator",
};
